import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=d945832e"
import script from "./orderItem.vue?vue&type=script&lang=js"
export * from "./orderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports